import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { AIAnswerSection } from './components/AIAnswerSection';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { ServiceAreas } from './components/ServiceAreas';
import { FAQ } from './components/FAQ';
import { ContactCTA } from './components/ContactCTA';
import { Footer } from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />
      <Hero />
      <TrustBar />
      <WhyChooseUs />
      <Services />
      <Process />
      <AIAnswerSection />
      <Gallery />
      <Testimonials />
      <ServiceAreas />
      <FAQ />
      <ContactCTA />
      <Footer />
    </div>
  );
}
